export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-12.fb6d70ae.png";